const SET_TITLE = 'SET_TITLE';
const SET_STATUS = 'SET_STATUS';
const SET_SUBTITLE = 'SET_SUBTITLE';
const SET_NO_MOSTRAR = 'SET_NO_MOSTRAR';
const SET_PENDING_TASK = 'SET_PENDING_TASK';
const SET_ALL_PENDING_TASK = 'SET_ALL_PENDING_TASK';
const DELETE_PENDING_TASK = 'DELETE_PENDING_TASK';

const state = {
  all_task_pending: null,
  tareas_pendientes: null,
  status: '',
  title: '',
  subtitle: '',
  colorRisks: {
    salud: 'rgb(0, 167, 245)',
    seguridad: 'rgb(179, 167, 0)',
    medioambiente: 'rgb(40, 134, 98)',
    personalizados: 'rgb(227, 0, 82)',
  },
};

const getters = {
  all_task_pending: state => state.all_task_pending,
  tareas_pendientes: state => state.tareas_pendientes,
  title: state => state.title,
  status: state => state.status,
  subtitle: state => state.subtitle,
  colorSalud: state => state.colorRisks.salud,
  colorSeguridad: state => state.colorRisks.seguridad,
  colorMedioambiente: state => state.colorRisks.medioambiente,
  colorPersonalizado: state => state.colorRisks.personalizados,
};

const actions = {
  setTitle({ commit }, newTitle) {
    commit(SET_TITLE, newTitle);
  },

  setStatus({ commit }, newStatus) {
    commit(SET_STATUS, newStatus);
  },

  setSubTitle({ commit }, newSubTitle) {
    commit(SET_SUBTITLE, newSubTitle);
  },

  setTareasPendientes({ commit }, tareas) {
    commit(SET_PENDING_TASK, tareas);
  },

  deleteRiesgosPendientes({ commit }, id_task) {
    commit(DELETE_PENDING_TASK, id_task);
  },

  setAllTareasPendientes({ commit }, tareas) {
    commit(SET_ALL_PENDING_TASK, tareas);
  },
};

const mutations = {
  [SET_TITLE](state, title) {
    state.title = title;
  },
  [SET_PENDING_TASK](state, tareas) {
    state.tareas_pendientes = tareas;
  },
  [DELETE_PENDING_TASK](state, id_task) {
    /* let pos = state.tareas_pendientes.risks.map(function (e) {
      return e.id_riesgo;
    }).indexOf(id_task);
    if (pos !== -1) {
      state.tareas_pendientes.risks.splice(pos, 1);
    } */
  },
  [SET_ALL_PENDING_TASK](state, tareas) {
    state.all_task_pending = tareas;
  },
  [SET_STATUS](state, status) {
    state.status = status;
  },
  [SET_SUBTITLE](state, subtitle) {
    state.subtitle = subtitle;
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
};
